/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SolicitorSearchResultDto } from './SolicitorSearchResultDto';
export type SolicitorSearchResponseDto = {
    /**
     * List of solicitors within the search radius
     */
    data: Array<SolicitorSearchResultDto>;
    /**
     * The search query used
     */
    query: string;
    /**
     * Type of query
     */
    queryType: SolicitorSearchResponseDto.queryType;
    /**
     * Center point of the search
     */
    center: Record<string, any>;
    /**
     * Search radius in kilometers
     */
    radius: number;
};
export namespace SolicitorSearchResponseDto {
    /**
     * Type of query
     */
    export enum queryType {
        POSTCODE = 'postcode',
        LOCATION = 'location',
    }
}

